/** The review-state words, typed only here. Pure data: no React. */
import type { ReviewState } from "./reviewState";

export const REVIEW_WORDS = {
  adjusted: "Adjusted",
  maintained: "Maintained",
  toReview: "Not yet reviewed",
  toReviewShort: "To review",
  maintain: "Maintain",
  more: "More",
  less: "Less",
  all: "All",
  open: "open",
  handled: "handled",
  decision: "decision",
  decisions: "decisions",
} as const;

/** The sign confirmation's count of open decisions nobody reviewed (OR-30.13): signing stays open; these keep the standing policy. The count is `ReviewTotals.toReview`, the number the footer shows. */
export const standingPolicyLine = (n: number): string => `${n} ${n === 1 ? "decision stays" : "decisions stay"} on your standing policy.`;

export const REVIEW_TAG: Readonly<Record<ReviewState, string>> = {
  adjusted: REVIEW_WORDS.adjusted,
  maintained: REVIEW_WORDS.maintained,
  toReview: REVIEW_WORDS.toReviewShort,
};
